// src/pages/mantenimiento/TabEquipos.jsx
// Catálogo ÚNICO de equipos — cubre F-MTO-01 (plan) y F-MTO-03
// (tickets). El checklist (F-MTO-08) es OPCIONAL por equipo: si lo
// tiene, se responde al cerrar un Ticket Preventivo de ese equipo.
import { useEffect, useState } from 'react';
import api from '../../services/api';
import styles from './estilos';
import { Campo } from './componentes';

function puntoVacio() { return { descripcion: '' }; }

function TabEquipos() {
  const [equipos, setEquipos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [mensaje, setMensaje] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [form, setForm] = useState({ codigo: '', area: '', descripcion: '', tipo_servicio: 'Interno', marca: '', modelo: '', numero_serie: '', cantidad: 1 });
  const [puntos, setPuntos] = useState([]);
  const [tieneChecklist, setTieneChecklist] = useState(false);
  const [duplicarDesde, setDuplicarDesde] = useState('');
  const [fotoBase64, setFotoBase64] = useState('');
  const [editandoId, setEditandoId] = useState(null);
  const [verInactivos, setVerInactivos] = useState(false);

  async function cargar() {
    try {
      setCargando(true);
      const res = await api.get('/api/mantenimiento/equipos');
      setEquipos(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }
  useEffect(() => { cargar(); }, []);

  function set(campo, valor) { setForm((prev) => ({ ...prev, [campo]: valor })); }

  function handleFoto(e) {
    const archivo = e.target.files[0];
    if (!archivo) return;
    const lector = new FileReader();
    lector.onload = () => {
      const img = new Image();
      img.onload = () => {
        const MAX_LADO = 500;
        let { width, height } = img;
        if (width > height && width > MAX_LADO) { height = Math.round(height * (MAX_LADO / width)); width = MAX_LADO; }
        else if (height > MAX_LADO) { width = Math.round(width * (MAX_LADO / height)); height = MAX_LADO; }
        const canvas = document.createElement('canvas');
        canvas.width = width; canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        setFotoBase64(canvas.toDataURL('image/jpeg', 0.75));
      };
      img.src = lector.result;
    };
    lector.readAsDataURL(archivo);
  }

  function handleEditar(equipo) {
    setEditandoId(equipo.id);
    setForm({
      codigo: equipo.codigo || '', area: equipo.area, descripcion: equipo.descripcion,
      tipo_servicio: equipo.tipo_servicio, marca: equipo.marca || '', modelo: equipo.modelo || '',
      numero_serie: equipo.numero_serie || '', cantidad: equipo.cantidad || 1,
    });
    setTieneChecklist(equipo.puntos.length > 0);
    setPuntos(equipo.puntos.length ? equipo.puntos.map((p) => ({ id: p.id, descripcion: p.descripcion })) : [puntoVacio()]);
    setFotoBase64(equipo.foto_base64 || '');
  }

  function handleCancelarEdicion() {
    setEditandoId(null);
    setForm({ codigo: '', area: '', descripcion: '', tipo_servicio: 'Interno', marca: '', modelo: '', numero_serie: '', cantidad: 1 });
    setPuntos([]);
    setTieneChecklist(false);
    setFotoBase64('');
    setDuplicarDesde('');
  }

  async function handleToggleActivo(equipo) {
    try {
      await api.put(`/api/mantenimiento/equipos/${equipo.id}/activo`, { activo: !equipo.activo });
      cargar();
    } catch (err) {
      console.error(err);
    }
  }

  function handleDuplicar(equipoId) {
    setDuplicarDesde(equipoId);
    if (!equipoId) return;
    const origen = equipos.find((e) => String(e.id) === String(equipoId));
    if (origen) setPuntos(origen.puntos.map((p) => ({ descripcion: p.descripcion })));
  }

  function handleToggleChecklist(activar) {
    setTieneChecklist(activar);
    if (activar && puntos.length === 0) setPuntos([puntoVacio()]);
  }

  function actualizarPunto(i, valor) {
    setPuntos((prev) => prev.map((p, idx) => (idx === i ? { ...p, descripcion: valor } : p)));
  }
  function agregarPunto() { setPuntos((prev) => [...prev, puntoVacio()]); }
  function quitarPunto(i) { setPuntos((prev) => prev.filter((_, idx) => idx !== i)); }

  async function handleGuardar() {
    if (!form.area || !form.descripcion) { setMensaje({ tipo: 'error', texto: 'Área y Descripción son obligatorios.' }); return; }
    try {
      setGuardando(true);
      setMensaje(null);
      const payload = { ...form, foto_base64: fotoBase64 || null, puntos: tieneChecklist ? puntos.filter((p) => p.descripcion.trim()) : [] };
      if (editandoId) {
        await api.put(`/api/mantenimiento/equipos/${editandoId}/completo`, payload);
        setMensaje({ tipo: 'ok', texto: '✓ Equipo actualizado.' });
      } else {
        await api.post('/api/mantenimiento/equipos', payload);
        setMensaje({ tipo: 'ok', texto: '✓ Equipo agregado.' });
      }
      handleCancelarEdicion();
      cargar();
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: err.response?.data?.error || 'No se pudo guardar.' });
    } finally {
      setGuardando(false);
    }
  }

  return (
    <div>
      <div style={styles.tarjeta}>
        <div style={styles.seccionTitulo}>
          {editandoId ? 'Editar Equipo' : 'Nuevo Equipo'}
          {editandoId && <button onClick={handleCancelarEdicion} style={{ ...styles.linkChico, marginLeft: 10 }}>Cancelar edición</button>}
        </div>
        <div style={styles.grid3}>
          <Campo label="Código (opcional)"><input type="text" value={form.codigo} onChange={(e) => set('codigo', e.target.value)} placeholder="Ej. HRN1" style={styles.input} /></Campo>
          <Campo label="Área"><input type="text" value={form.area} onChange={(e) => set('area', e.target.value)} placeholder="Ej. Hornos" style={styles.input} /></Campo>
          <Campo label="Tipo de servicio">
            <select value={form.tipo_servicio} onChange={(e) => set('tipo_servicio', e.target.value)} style={styles.input}>
              <option value="Interno">Interno</option>
              <option value="Externo">Externo</option>
            </select>
          </Campo>
        </div>
        <Campo label="Descripción"><input type="text" value={form.descripcion} onChange={(e) => set('descripcion', e.target.value)} style={{ ...styles.input, width: '100%' }} /></Campo>
        <div style={styles.grid3}>
          <Campo label="Marca"><input type="text" value={form.marca} onChange={(e) => set('marca', e.target.value)} style={styles.input} /></Campo>
          <Campo label="Modelo"><input type="text" value={form.modelo} onChange={(e) => set('modelo', e.target.value)} style={styles.input} /></Campo>
          <Campo label="Cantidad"><input type="number" min="1" value={form.cantidad} onChange={(e) => set('cantidad', e.target.value)} style={styles.input} /></Campo>
        </div>

        <Campo label="Foto del equipo (opcional)">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <input type="file" accept="image/*" onChange={handleFoto} style={{ fontSize: 12 }} />
            {fotoBase64 && <img src={fotoBase64} alt="preview" style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 8, border: '1px solid #E6DDD2' }} />}
          </div>
        </Campo>

        <div style={{ marginTop: 16, paddingTop: 14, borderTop: '1px solid #F0E9E0' }}>
          <label style={{ fontSize: 12, display: 'flex', alignItems: 'center', gap: 6, color: '#6E4F80', fontWeight: 600 }}>
            <input type="checkbox" checked={tieneChecklist} onChange={(e) => handleToggleChecklist(e.target.checked)} />
            Este equipo tiene checklist de inspección propio (F-MTO-08) — solo aplica a maquinaria
          </label>

          {tieneChecklist && (
            <div style={{ marginTop: 12 }}>
              <Campo label="Duplicar puntos desde otro equipo (opcional, punto de partida editable)">
                <select value={duplicarDesde} onChange={(e) => handleDuplicar(e.target.value)} style={styles.input}>
                  <option value="">Empezar en blanco</option>
                  {equipos.filter((e) => e.puntos.length > 0).map((e) => <option key={e.id} value={e.id}>{e.descripcion}</option>)}
                </select>
              </Campo>

              <div style={{ fontSize: 11, color: '#6E4F80', fontWeight: 700, textTransform: 'uppercase', margin: '10px 0 6px' }}>Puntos de inspección</div>
              {puntos.map((p, i) => (
                <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 6 }}>
                  <span style={{ fontSize: 12, color: '#8A7690', width: 20, paddingTop: 8 }}>{i + 1}.</span>
                  <input type="text" value={p.descripcion} onChange={(e) => actualizarPunto(i, e.target.value)} placeholder="Ej. Revisión de botoneras..." style={{ ...styles.input, flex: 1 }} />
                  {puntos.length > 1 && <button onClick={() => quitarPunto(i)} style={styles.botonQuitarFila}>✕</button>}
                </div>
              ))}
              <button onClick={agregarPunto} style={styles.botonAgregarFila}>+ Agregar punto</button>
            </div>
          )}
        </div>

        {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}
        <button onClick={handleGuardar} disabled={guardando} style={styles.botonGuardar}>{guardando ? 'Guardando...' : editandoId ? 'Guardar Cambios' : 'Guardar Equipo'}</button>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '20px' }}>
        <h2 style={styles.subtituloLista}>Catálogo de Equipos ({equipos.filter((e) => verInactivos || e.activo).length})</h2>
        <label style={{ fontSize: 12, color: '#6E4F80', display: 'flex', alignItems: 'center', gap: 6 }}>
          <input type="checkbox" checked={verInactivos} onChange={(e) => setVerInactivos(e.target.checked)} /> Ver desactivados
        </label>
      </div>
      {cargando ? <div>Cargando...</div> : (
        <div style={styles.tablaScroll}>
          <table style={styles.tabla}>
            <thead><tr><th style={styles.th}>Foto</th><th style={styles.th}>Código</th><th style={styles.th}>Área</th><th style={styles.th}>Descripción</th><th style={styles.th}>Checklist</th><th style={styles.th}></th></tr></thead>
            <tbody>
              {equipos.filter((e) => verInactivos || e.activo).map((e) => (
                <tr key={e.id} style={{ opacity: e.activo ? 1 : 0.5 }}>
                  <td style={styles.td}>{e.foto_base64 ? <img src={e.foto_base64} alt={e.descripcion} style={{ width: 36, height: 36, objectFit: 'cover', borderRadius: 6 }} /> : '—'}</td>
                  <td style={styles.td}>{e.codigo || '—'}</td>
                  <td style={styles.td}>{e.area}</td>
                  <td style={styles.td}>{e.descripcion}{!e.activo && <span style={{ color: '#B23A48', fontSize: 10, marginLeft: 6 }}>(inactivo)</span>}</td>
                  <td style={styles.td}>{e.puntos.length > 0 ? `✓ ${e.puntos.length} puntos` : '—'}</td>
                  <td style={styles.td}>
                    <button onClick={() => handleEditar(e)} style={styles.linkChico}>Editar</button>
                    {' · '}
                    <button onClick={() => handleToggleActivo(e)} style={{ ...styles.linkChico, color: e.activo ? '#B23A48' : '#3E7C5A' }}>
                      {e.activo ? 'Desactivar' : 'Reactivar'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {equipos.length === 0 && <p style={{ padding: 16, color: '#8A7690', fontSize: 12 }}>Sin equipos capturados todavía.</p>}
        </div>
      )}
    </div>
  );
}

export default TabEquipos;